var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "select-event-type"
    }
  }, [_c('div', {
    staticClass: "position-relative"
  }, [_c('div', {
    class: _vm.$style.eventDivSelect,
    on: {
      "click": function click($event) {
        _vm.calendarCheckboxShow = !_vm.calendarCheckboxShow;
      }
    }
  }, [!_vm.selectedEventType.length ? _c('span', [_vm._v("All Event Types")]) : _vm._e(), _vm.selectedEventType.length === 1 ? _c('span', [_vm._v(_vm._s(_vm.selectedEventType[0]))]) : _vm._e(), _vm.selectedEventType.length > 1 ? _c('span', [_vm._v(_vm._s(_vm.selectedEventType.length) + " Event Types Selected")]) : _vm._e()]), _c('BaseIcon', {
    class: _vm.$style.eventDivSelectDownArrow,
    attrs: {
      "name": "chevron-down"
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.calendarCheckboxShow,
      expression: "calendarCheckboxShow"
    }],
    class: _vm.$style.calendarCheckbox
  }, _vm._l(_vm.getEventTypes, function (eventType) {
    var _class;
    return _c('div', {
      key: eventType,
      class: _vm.$style.calendarCheckboxItem
    }, [_c('label', {
      class: _vm.$style.container
    }, [_c('span', [_vm._v(_vm._s(eventType))]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.selectedEventType,
        expression: "selectedEventType"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": eventType,
        "checked": Array.isArray(_vm.selectedEventType) ? _vm._i(_vm.selectedEventType, eventType) > -1 : _vm.selectedEventType
      },
      on: {
        "change": function change($event) {
          var $$a = _vm.selectedEventType,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;
          if (Array.isArray($$a)) {
            var $$v = eventType,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedEventType = $$a.concat([$$v]));
            } else {
              $$i > -1 && (_vm.selectedEventType = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.selectedEventType = $$c;
          }
        }
      }
    }), _c('span', {
      class: (_class = {}, _class[_vm.$style.checkmark] = true, _class[_vm.getEventColorClass(eventType)] = true, _class)
    })])]);
  }), 0)]);
}
var staticRenderFns = []

export { render, staticRenderFns }